import { OTB_EDITABLE_FIELDS } from '../../../../components/components.constants'

const BASE_EDITABLE_FIELDS = [
    OTB_EDITABLE_FIELDS.FATURAMENTO, 
    OTB_EDITABLE_FIELDS.PRECO_MEDIO, 
    OTB_EDITABLE_FIELDS.PECAS_VENDIDAS]
;

export const isOtbEditableField = (fieldKey) => BASE_EDITABLE_FIELDS.includes(fieldKey);